import React from "react";
import TopBanner from "../components/TopBanner";
import styled from "styled-components";
import Form from "../components/Form";

export const UnitLinkedInsurancePlans = () => {
  return (
    <>
      <TopBanner content={"Unit Linked Insurance Plans"} />
      <ContentWrapper>
        <div className="text-content">
          <h2>One Plan. Two Benefits.</h2>
          <p>
            A Unit-Linked Insurance Plan (ULIP) combines investment and
            insurance into a single plan. While a part of your premium goes
            toward life insurance, the rest is invested in market-linked funds
            like equity or debt helping you build wealth over time.
          </p>

          <p>
            ULIPs offer flexibility to switch funds, choose risk levels, and
            even withdraw partially after a lock-in period. It’s an ideal plan
            for those looking for growth, protection, and tax savings all in
            one.
          </p>

          <h3>Why Choose ULIPs?</h3>
          <ul>
            <li>Dual benefit: Life cover + Investment returns</li>
            <li>Choose from equity, debt, or hybrid funds</li>
            <li>Tax savings under Section 80C and 10(10D) </li>
            <li>Option to switch funds based on market trends</li>
            <li>Lock-in period of 5 years, then partial withdrawals allowed</li>
          </ul>
        </div>
        <Form />
      </ContentWrapper>
    </>
  );
};

export default UnitLinkedInsurancePlans;

export const ContentWrapper = styled.div`
  display: flex;
  padding: 100px;
  gap: 20px;

  .text-content {
    width: 50%;
    p,
    ul,
    li {
      font-size: 1.1rem;
      line-height: 1.6;
      color: #333;
      text-align: left;
    }
  }

  h3 {
    color: black;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 30px;

    .text-content {
      width: 100%;
    }
  }
`;
